// extracted by mini-css-extract-plugin
export default {"container":"style_container__pRbKL","icon":"style_icon__ysAhW"};